import { render, staticRenderFns } from "./PrintGroupsForm.vue?vue&type=template&id=aa043da4"
import script from "./PrintGroupsForm.vue?vue&type=script&lang=ts"
export * from "./PrintGroupsForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports